const endpoints = {
   loginWithEmail: 'email/login/v1/',
   verifyOTP: 'email/login_otp/verify/v1/',
   sendOTP: 'email/login_otp/send/v1/',
   refreshAuthTokens: 'refresh_auth_tokens/v1/',
   logout: 'logout/v1/'
}
export default endpoints

export const endpointsForUsername = {
   loginWithUsername: 'username/login/v1/',
   verifyOTP: 'username/login_otp/verify/v1/',
   sendOTP: 'username/login_otp/send/v1/'
}
